import type { ConnectionPositionPair } from '@angular/cdk/overlay';
import type { TemplateRef } from '@angular/core';
import { Component, Input, output } from '@angular/core';

import type { AttributeListData } from '@core/http-types';
import type { ListTemplateContext } from '@core/user-interface-legacy';
import { AttributesComponent } from '@core/user-interface-legacy';

import type { DepartmentAttribute } from '../../types/departments.types';

@Component({
  selector: 'rt-department-select',
  templateUrl: './department-select.component.html',
  imports: [AttributesComponent],
})
export class DepartmentSelectComponent {
  @Input() public selected: DepartmentAttribute[] = [];
  @Input() public canCreate: boolean;
  @Input() public suggestions: AttributeListData;
  @Input() public dropdownPositions: ConnectionPositionPair[] | null;
  @Input() public listTpl: TemplateRef<ListTemplateContext> | null;
  @Input() public selectFooterTemplate: TemplateRef<any> | null;
  @Input() public selectHeaderTemplate: TemplateRef<any> | null;
  @Input() public toggleDropdown: boolean;
  @Input() public hasTriggerWidth = true;
  @Input() public markSelected = false;

  public query = output<string>();
  public select = output<DepartmentAttribute>();
  public remove = output<DepartmentAttribute>();
  public goToSettings = output<void>();
}
